@import "../../globalStyles/commons";


:host {
  display: block;
  margin-bottom: v(--spacing-03);
}


:host(:not([inline])) {
  width: 18rem;
}

.notification {
  border-style: solid;
  border-color: transparent;
  display: flex;

  .state-icon {
    padding: 0.875rem v(--spacing-04);
    line-height: 0;
  }

  .content {
    flex: 1;
    padding-block: v(--spacing-04);

    .title {
      @include font-style(heading-compact-01);
      word-break: break-word;
    }

    .subtitle {
      @include font-style(body-compact-01);
      word-break: break-word;
    }

    .actions {
      display: flex;
      align-items: center;
      gap: var(--spacing-04);
      padding-top: 1.5rem;

      .action {
        --goat-button-border-radius: none;
      }
    }
  }


  &.inline .content {
    display: flex;
    padding-block: 0;

    .content-text {
      flex: 1;
      padding-block: v(--spacing-04);

      .title, .subtitle {
        display: inline;
        padding-inline-end: .25rem;
      }

      .title slot::slotted(*), .subtitle slot::slotted(*) {
        display: inline;
      }


    }

    .actions {
      padding-top: 0;
      padding-inline-end: v(--spacing-03);
    }
  }


  .close-button {
    margin: 0;
    --goat-button-padding: .75rem;
    --goat-button-height: 3rem;
    --goat-button-border-radius: none;
  }
}

:host(:not([dismissible])) .content {
  padding-inline-end: v(--spacing-04);
}


@mixin alertState($color, $dark) {
  @if $dark {
    .alert {
      background-color: v(--color-#{$color});

      .content {
        .message {
          color: white;
          --link-color: white;
        }

        .description {
          color: v(--text-primary);
        }
      }
    }
  } @else {
    .alert {
      background-color: v(--color-#{$color}-20);

      .content {
        .message {
          color: v(--color-#{$color}-70);
          --link-color: #{v(--color-#{$color}-70)};
        }

        .description {
          color: v(--text-secondary);
        }
      }
    }
  }
}

@each $state in [info, success, warning, error] {

  .notification.state-#{$state} {

    &.high-contrast {
      border-left-color: v(--support-#{$state}-inverse);
      color: v(--text-inverse);
      background: v(--background-inverse);
      border-width: 0 0 0 3px;

      .close-button {
        .icon {
          color: v(--text-inverse);
        }
      }

      .state-icon {
        color: v(--support-#{$state}-inverse);
      }
    }

    &:not(.high-contrast) {
      color: v(--color-neutral-100);
      border-color: v(--support-#{$state});
      background: v(--color-#{$state}-10);
      border-width: 1px 1px 1px 3px;

      .close-button {
        .icon {
          --icon-color: v(--color-neutral-100);
        }
      }

      .state-icon {
        color: v(--support-#{$state});
      }
    }
  }

}
